<router-outlet></router-outlet>
<app-toast></app-toast>
<div>
  <p-confirmDialog [header]="'common.confirm' | translate"
                   styleClass="tw-page tw-confirm-dialog"
                   acceptButtonStyleClass="tw-btn-primary"
                   rejectButtonStyleClass="tw-btn-transparent">
  </p-confirmDialog>
</div>
